import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=d3e3c686&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"
import style0 from "./welcome.vue?vue&type=style&index=0&id=d3e3c686&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e3c686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3e3c686')) {
      api.createRecord('d3e3c686', component.options)
    } else {
      api.reload('d3e3c686', component.options)
    }
    module.hot.accept("./welcome.vue?vue&type=template&id=d3e3c686&scoped=true", function () {
      api.rerender('d3e3c686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/welcome.vue"
export default component.exports